import { ChangeDetectionStrategy, Component, computed, inject, Signal } from '@angular/core';
import { TStrapiTag } from '@core/types/strapi.type';
import { ArticlesHeroImports } from '@pages/articles/hero/articles-hero.imports';
import { ArticlesDataService } from '@pages/articles/services/articles.data.service';
import type { SwiperOptions } from 'swiper';

@Component({
  selector: 'noda-articles-hero',
  standalone: true,
  templateUrl: './articles-hero.component.html',
  styleUrls: ['./articles-hero.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: ArticlesHeroImports,
})
export class ArticlesHeroComponent {
  private articlesDataService: ArticlesDataService = inject(ArticlesDataService);

  protected tags: Signal<TStrapiTag[]> = computed(() => this.articlesDataService.currentLangTags());

  public config: SwiperOptions = {
    slidesPerView: 'auto',
    spaceBetween: 4,
    breakpoints: {
      768: {
        allowTouchMove: false,
        noSwiping: true,
      },
    },
  };
}
